import angular from 'angular';
import moment from 'moment';
import uiRouter from 'angular-ui-router';
import routing from './reporting.routes';

export class ReportingController {
  /*@ngInject*/
  constructor($http, $scope, $location, appConfig, Auth, toastr) {
    var vm = this;
    vm.orderBy = "client";
    vm.reverseSort = false;
    vm.loading = true;
    vm.data = {};
    vm.filters = {
      sites : {},
      categories : {},
      personnes : {},
      societes : {},
      postes : {}
    };
    $scope._ = _;
    vm.startDate = moment().startOf('day').format('YYYY / MM / DD');

    /* $http.get('/api/sites').then(response => {
      vm.sites = response.data;
      return $http.get('/api/badges')
    }).then(badgeResponse => {
        vm.badges = badgeResponse.data;
        vm.loading = false;
        vm.data.start = moment(vm.startDate).startOf('day').toDate();
        vm.data.end = moment(vm.endDate).endOf('day').toDate();
        vm.initDatas();
        setTimeout(function() {
          vm.data.site = vm.sites[0];
          $('.selectpicker').selectpicker('val', vm.sites[0]);
          $('.selectpicker').selectpicker('refresh');
        }, 10);
      }); */

    $http.get('/api/users/my/sites').then(response => {
      if(response.data.Sites.length == 0) {
        return $http.get('/api/sites').then(response => {
          vm.sites = response.data;
          return $http.get('/api/badges');
        })
      } else {
        vm.sites = response.data.Sites;
        return $http.get('/api/badges');
      }
    }).then(badgeResponse => {
      console.log(badgeResponse)
      vm.badges = badgeResponse.data;
      vm.loading = false;
      vm.data.start = moment(vm.startDate).startOf('day').toDate();
      vm.data.end = moment(vm.endDate).endOf('day').toDate();
      vm.initDatas();
      setTimeout(function() {
        vm.data.site = vm.sites[0];
        $('.selectpicker').selectpicker('val', vm.sites[0]);
        $('.selectpicker').selectpicker('refresh');
      }, 10);
    });

    vm.initDatas = function () {
      vm.filterSites = angular.copy(vm.sites);
      vm.filterBadges = _(vm.badges).filter(function(badge){
        return ((!vm.data.start || (vm.data.start < moment(badge.createdAt).toDate()))
          && (!vm.data.end || (vm.data.end >= moment(badge.createdAt).toDate()))
        )
      }).value()

      _(vm.filterBadges)
      .forEach(function (badge) {
        var cat = _(vm.filterSites)
        .flatMap('Postes')
        .flatMap('Categories')
        .find(['_id', badge.session.category._id]);

        var poste = _(vm.filterSites)
        .flatMap('Postes')
        .find(['_id', cat.posteId]);
        cat.persoAcc ?  cat.persoAcc ++ : cat.persoAcc = 1;
        cat.spentTime ? cat.spentTime += badge.session.timeSpent : cat.spentTime = badge.session.timeSpent;
        cat.spentTimeMean = (cat.spentTime / cat.persoAcc);
        poste.persoAcc = cat.persoAcc;
        poste.spentTime = cat.spentTime;
        poste.spentTimeMean = cat.spentTimeMean;
      })

      var addition = _(vm.filterSites).forEach(function(site){
        var persoAccCount = _(site.Postes)
        .flatMap('Categories')
        .flatMap('persoAcc').sum()
        var spentTimeCount = _(site.Postes)
        .flatMap('Categories')
        .flatMap('spentTime').sum()
        site.persoAcc = persoAccCount;
        site.spentTimeMean = (spentTimeCount / persoAccCount);
      })

      vm.personnes = _(vm.filterBadges)
      .groupBy('name')
      .toPairs()
      .map(function(pair){
        var personne = {}
        _(pair[1])
        .flatMap('session')
        personne.participations = _(pair[1]).flatMap('session').value()
        personne.spentTimeMean = (_(pair[1]).flatMap('session.timeSpent').sum() / pair[1].length)
        personne.lastVisit = _(pair[1]).flatMap('updatedAt').max()
        return [pair[0], personne]
      }).value()

      vm.societes = _(vm.filterBadges)
      .groupBy('session.collecte.Societe')
      .toPairs()
      .map(function(pair){
        var societe = {}
        _(pair[1])
        .flatMap('session')
        societe.participations = _(pair[1]).flatMap('session').value()
        societe.spentTimeMean = (_(pair[1]).flatMap('session.timeSpent').sum() / pair[1].length)
        societe.lastVisit = _(pair[1]).flatMap('updatedAt').max()
        return [pair[0], societe]
      }).value()

      /*var addition = _(vm.sites)
      .groupBy('name')
      .toPairs()
      .map(function(pair){
        var amount = _(pair[1])
          .flatMap('Postes')
          .flatMap('Categories')
          .flatMap('persoAcc')
          .sum()
        return [pair[0], amount]
      })
      .fromPairs()
      .value()*/
      // console.log(addition)
    }

    $scope.$watch('vm.startDate', function(newV){
      if(vm.data){
        vm.data.start = moment(newV).startOf('day').toDate();
        vm.initDatas();
      }
    })

    $scope.$watch('vm.endDate', function(newV){
      if(vm.data){
        vm.data.end = moment(newV).endOf('day').toDate();
        vm.initDatas();
      }
    })

    vm.filteredSites = function () {
      return _.filter(vm.filterSites, function (site) {
        return ((!vm.filters.sites.name || (site.name.toLowerCase().includes(vm.filters.sites.name.toLowerCase())))
          && (!vm.filters.sites.persoMin || (vm.filters.sites.persoMin <= site.persoAcc))
          && (!vm.filters.sites.persoMax || (vm.filters.sites.persoMax >= site.persoAcc))
          && (!vm.filters.sites.timeMin || (vm.filters.sites.timeMin <= site.spentTimeMean))
          && (!vm.filters.sites.timeMax || (vm.filters.sites.timeMax >= site.spentTimeMean))
          )
      })
    }

    vm.filteredCategorie = function () {
      if(vm.selectedSite) {
        vm.categories = _(_(vm.filteredSites())
        .find(['_id',vm.selectedSite._id]).Postes)
        .flatMap('Categories').value()
      } else {
        vm.categories = _(vm.filteredSites())
        .flatMap('Postes')
        .flatMap('Categories').value()
      }

      return _.filter(vm.categories, function (categorie) {
        return (
          (!vm.filters.categories.name || (categorie.name.toLowerCase().includes(vm.filters.categories.name.toLowerCase())))
          && (!vm.filters.categories.persoMin || (vm.filters.categories.persoMin <= categorie.persoAcc))
          && (!vm.filters.categories.persoMax || (vm.filters.categories.persoMax >= categorie.persoAcc))
          && (!vm.filters.categories.timeMin || (vm.filters.categories.timeMin <= categorie.spentTimeMean))
          && (!vm.filters.categories.timeMax || (vm.filters.categories.timeMax >= categorie.spentTimeMean))
        )
      })
    }

    vm.filteredPostes = function () {
      if(vm.selectedSite) {
        vm.postes = _(vm.filteredSites())
        .find(['_id',vm.selectedSite._id]).Postes
      } else {
        vm.postes = _(vm.filteredSites())
        .flatMap('Postes').value()
      }

      return _.filter(vm.postes, function (poste) {
        return (
          (!vm.filters.postes.name || (poste.name.toLowerCase().includes(vm.filters.postes.name.toLowerCase())))
          && (!vm.filters.postes.persoMin || (vm.filters.postes.persoMin <= poste.persoAcc))
          && (!vm.filters.postes.persoMax || (vm.filters.postes.persoMax >= poste.persoAcc))
          && (!vm.filters.postes.timeMin || (vm.filters.postes.timeMin <= poste.spentTimeMean))
          && (!vm.filters.postes.timeMax || (vm.filters.postes.timeMax >= poste.spentTimeMean))
        )
      })
    }

    vm.filteredPersonnes = function () {
      return _.filter(vm.personnes, function (personne) {
        if(vm.selectedSite) {
          personne[1].parts = _.filter(personne[1].participations, function(part){
            return (vm.selectedSite._id == part.site._id)
          }).length
        } else {
          personne[1].parts = personne[1].participations.length
        }
        return (
          (!vm.filters.personnes.name || (personne[0].toLowerCase().includes(vm.filters.personnes.name.toLowerCase())))
          && (!vm.filters.personnes.persoMin || (vm.filters.personnes.persoMin <= personne[1].parts))
          && (!vm.filters.personnes.persoMax || (vm.filters.personnes.persoMax >= personne[1].parts))
          && (!vm.filters.personnes.timeMin || (vm.filters.personnes.timeMin <= personne[1].spentTimeMean))
          && (!vm.filters.personnes.timeMax || (vm.filters.personnes.timeMax >= personne[1].spentTimeMean))
        )
      })
    }

    vm.filteredSocietes = function () {
      return _.filter(vm.societes, function (societe) {
        if(vm.selectedSite) {
          societe[1].parts = _.filter(societe[1].participations, function(part){
            return (vm.selectedSite._id == part.site._id)
          }).length
        } else {
          societe[1].parts = societe[1].participations.length
        }
        return (
          (!vm.filters.societes.name || (societe[0].toLowerCase().includes(vm.filters.societes.name.toLowerCase())))
          && (!vm.filters.societes.persoMin || (vm.filters.societes.persoMin <= societe[1].parts))
          && (!vm.filters.societes.persoMax || (vm.filters.societes.persoMax >= societe[1].parts))
          && (!vm.filters.societes.timeMin || (vm.filters.societes.timeMin <= societe[1].spentTimeMean))
          && (!vm.filters.societes.timeMax || (vm.filters.societes.timeMax >= societe[1].spentTimeMean))
        )
      })
    }

    vm.clearFilters = function(filters){
      if(filters == 'sites') {
        vm.filters.sites = {};
        vm.selectedSite = undefined;
      }
      if(filters == 'categories') {
        vm.filters.categories = {};
      }
      if(filters == 'postes') {
        vm.filters.postes = {};
      }
      if(filters == 'personnes') {
        vm.filters.personnes = {};
      }
    }

    vm.selectSite = function(site){
      if(vm.selectedSite && (site._id == vm.selectedSite._id)) vm.selectedSite = undefined;
      else vm.selectedSite = site;
    }

    vm.getBadgeList = function(){
      $http.get('/api/badges/csv/list').then(function(res){
        if(res.data.error) return toastr.warning('Pas de personnes présentes', 'Impossible');
        window.open(res.data.url);
      }).catch(function(err){
        console.log(err)
      })
    }
  }
}

export default angular.module('aperamApp.reporting', [uiRouter])
  .config(routing)
  .component('reporting', {
    template: require('./reporting.html'),
    controller: ReportingController,
    controllerAs:'vm'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/reporting/reporting.component.js